import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';


@Component({
  selector: 'app-features',
  templateUrl: './features.component.html',
  styleUrls: ['./features.component.scss']
})
export class FeaturesComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

  }

}
